import ApiService from "@/core/services/api.service";

export default {
  sign_up (data = {}) {
    return ApiService.post('auth/sign_up', data)
  },
  confirm (data = {}) {
    return ApiService.post('auth/confirm', data)
  },
  repeatCode () {
    return ApiService.post('auth/repeat_code')
  },
  repeatCodeByPhone (data = {}) {
    return ApiService.post('auth/repeat_code_by_phone', data)
  },
  resetPassword (data = {}) {
    return ApiService.post('auth/reset_password', data)
  }
}
